<div class="selected-challenges py-3 px-4 flex flex-col gap-2">
  <h2 class="selected-challenges-header text-xs font-bold uppercase">Selected Challenges</h2>
  @if (store.selectedChallenges() && store.selectedChallenges().length) {
    <div class="flex gap-1 flex-wrap">
      @for (pairChallenge of store.selectedChallenges(); track pairChallenge.subChallengeName) {
        <div class="selected-challenges-content">
          <span>{{ pairChallenge.challengeName }} - {{ pairChallenge.subChallengeName }}</span>
        </div>
      }
    </div>
  }
</div>
